import { lazy, Suspense, useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Layout from "../Layout";
import { logout } from "../redux/auth/authSlice";
import { showToast } from "../utils/toast";

const LandingPage = lazy(() => import("../pages/landing/LandingPage"));
const Login = lazy(() => import("../pages/onboarding/Login"));
const Dashboard = lazy(() => import("../pages/dashboard/Dashboard"));
const AllSharedFileFolder = lazy(
  () => import("../pages/sharedfiles/AllSharedFileFolder"),
);
const FileInFolder = lazy(() => import("../pages/sharedfiles/FileInFolder"));
const DetailViewOfDocument = lazy(
  () => import("../components/DetailViewOfDocument"),
);
const SignUp = lazy(() => import("../pages/onboarding/SignUp"));

const PrivacyPolicy = lazy(
  () => import("../pages/privacyPolicy/PrivacyPolicy"),
);
const TermsAndCondition = lazy(
  () => import("../pages/privacyPolicy/TermsAndCondition"),
);

const PrivateRoute = ({ children }) => {
  const { isLoggedIn, role } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  if (!isLoggedIn) return <Navigate to="/" replace />;

  if (role === 0) {
    dispatch(logout());
    return <Navigate to="/login" replace />;
  }

  return children;
};

const PublicRoute = ({ children }) => {
  const { isLoggedIn } = useSelector((state) => state.auth);
  return !isLoggedIn ? children : <Navigate to="/dashboard" replace />;
};

const AppRoutes = () => {
  return (
    <Suspense
      fallback={
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          Loading...
        </div>
      }
    >
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-condition" element={<TermsAndCondition />} />
        <Route
          path="/login"
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />
        <Route
          path="/register"
          element={
            <PublicRoute>
              <SignUp />
            </PublicRoute>
          }
        />

        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Layout>
                <Dashboard />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/shared-items"
          element={
            <PrivateRoute>
              <Layout>
                <AllSharedFileFolder />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/shared-folder-files"
          element={
            <PrivateRoute>
              <Layout>
                <FileInFolder />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route path="/document-detail" element={<DetailViewOfDocument />} />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  );
};

export default AppRoutes;
